import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ErrorMessages } from 'src/app/shared/common/errormessages';
import { CommonService } from 'src/app/shared/services/common.service';
import { MappingtypeComponent } from '../mappingtype.component';
import { constants } from 'src/app/shared/common/contants';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { validationmethod } from 'src/app/shared/models/validationmethod';

export interface mappingtype{
  edata: any;
}
@Component({
    selector: 'app-mappingtype-popup-screen',
    templateUrl: './mappingtype-popup-screen.component.html',
    styleUrls: ['./mappingtype-popup-screen.component.scss'],
    standalone: false
})
export class MappingtypePopupScreenComponent implements OnInit {

  
    backgroundColorButton;
    FormValid: UntypedFormGroup;
    updatedData;
    uploadId;
    name;
    validation_messages: any;
    mappingtypename
    buttonName
    idColumn
    formValidCheckbox: UntypedFormGroup;
    isCheckboxSelected=false;
    showCreateAnother=true;

    mappingtype = {
      'mappingtypename':'',
      'mappingTypeId':''
    }
  
    constructor(private commonservice: CommonService, public dialogRef:MatDialogRef<MappingtypeComponent>,private validation:validationmethod,private localstorage:LocalStorageSettingsService,
      private errormessage:ErrorMessages,private spinner: NgxUiLoaderService,private snackbar:MatSnackBar, @Inject(MAT_DIALOG_DATA) public data: mappingtype, private constants:constants,private fb: UntypedFormBuilder
    ) { }
  /*
  Author- Venkata Shyam
  04-04-2025
  For creation of mapping type popup screen
*/
    ngOnInit(): void {
      this.buttonName = 'Save'
      console.log( this.data.edata)
      this.updatedData = this.data.edata
      if(this.updatedData.mappingTypeId != undefined){
        this.buttonName = 'Update'
        this.showCreateAnother = false;
        console.log("mappingtypename",this.updatedData.mappingTypeName)
        // this.FormValid.get('mappingtypename')?.setValue(this.updatedData.mappingTypeName);
        this.mappingtype.mappingtypename = this.updatedData.mappingTypeName
        this.mappingtype.mappingTypeId = this.updatedData.mappingTypeId
      }
      console.log(this.data)
      this.backgroundColorButton = this.localstorage.getSettings('ColorA');
     
      this.formvalidations();
      // this.FormValid.get('mappingtypename')?.setValue(this.mappingtypename);
      this.formValidationsCheckbox();

    }
    cancel(){
      this.dialogRef.close();
    }
  
     formValidationsCheckbox() {
  this.formValidCheckbox = new UntypedFormGroup({
    isCheckboxSelected: new UntypedFormControl(false)
  });
}

    formvalidations(){
      this.FormValid = new UntypedFormGroup({
        'mappingtypename' : new UntypedFormControl('',
        [
          Validators.required,
          Validators.pattern('^(?=.*[a-zA-Z0-9])[a-zA-Z0-9_-]+$')
        ])
      })
    }
  
    saveMethod(){
      if(!this.FormValid.valid ){
         const message = this.FormValid.pristine
          ? 'All mandatory fields to be filled.'
          : 'Please correct the highlighted validation errors before submitting.';
            this.snackbar.open(message,"ok",{duration:3000});
            return
        }
      // console.log(this.functional)
      // const formdata = this.functional
      console.log('Saving Data:', this.FormValid.value.mappingtypename);
      var dnsid = localStorage.getItem('dnsName');
      if(this.buttonName == 'Update'){
       this.idColumn =  this.mappingtype.mappingTypeId ;
      }else{
        this.idColumn = 0;
      }
      const requestData = {
        mappingTypeName: this.mappingtype.mappingtypename,// Adjust based on API field names
        tenantId : dnsid,
        mappingTypeId: this.idColumn
      };
      this.commonservice.saveMappingtype(requestData).subscribe({
        next: (response) => {
          console.log('edit successful', response);
          console.log(response.data)
          this.updatedData = null;
          this.snackbar.open(response.statusMessage, 'OK', { duration: 3000 });
          if (this.isCheckboxSelected && this.buttonName === 'Save') {
          this.FormValid.reset();
          this.mappingtype.mappingtypename = '';
          this.mappingtype.mappingTypeId = '';
          this.buttonName = 'Save';
        } else {
          this.dialogRef.close(response.data);
        }
        },
        error: (error: any) => {
          console.error('retrieve failed', error);
          
        },
        complete: () => {
          console.log('retrieve  completed');
          this.updatedData = null
        }
      });
    }

}
